import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "46",
  height: "46",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "23",
      cy: "23",
      r: "22.5",
      fill: "currentColor",
      stroke: "#EBEBEB"
    }, null, -1)
  ]))]))
}
export default { render: render }